import React, { useEffect } from "react";
import "../styles/geoAndDecComp1.css";
import "../styles/futuresComp4.css";
import ShapesFutures1 from "../assets/futures/IMG_4975_edited.jpg";
import ShapesFutures2 from "../assets/futures/IMG_4977_edited.jpg";
import ShapesFutures3 from "../assets/futures/IMG_4994_edited.jpg";

const FuturesComp4 = () => {
  useEffect(() => {
    const container = document.querySelector(".container");
    const content = document.querySelector(".scroll-content");
    const thumb = document.querySelector(".scrollbar-thumb");

    // Helper functions to disable and enable text selection
    const disableTextSelection = () => {
      document.body.style.userSelect = "none"; // Disable text selection
    };

    const enableTextSelection = () => {
      document.body.style.userSelect = ""; // Re-enable text selection
    };

    const updateThumbPosition = () => {
      const contentWidth = content.scrollWidth;
      const containerWidth = container.clientWidth;
      const scrollLeft = content.scrollLeft;

      const thumbWidth = Math.max(
        (containerWidth / contentWidth) * containerWidth,
        50
      );
      const thumbLeft = (scrollLeft / contentWidth) * containerWidth;

      thumb.style.width = `${thumbWidth}px`;
      thumb.style.left = `${thumbLeft}px`;
    };

    content.addEventListener("scroll", updateThumbPosition);
    updateThumbPosition();

    const startDrag = (e, isTouch = false) => {
      e.preventDefault(); // Add this line
      disableTextSelection();

      const startX = isTouch ? e.touches[0].clientX : e.clientX;
      const startLeft = parseFloat(thumb.style.left) || 0; // Add fallback

      const onMove = (moveEvent) => {
        moveEvent.preventDefault(); // Add this line
        const clientX = isTouch
          ? moveEvent.touches[0].clientX
          : moveEvent.clientX;
        const deltaX = clientX - startX;
        const newLeft = Math.min(
          container.clientWidth - thumb.clientWidth,
          Math.max(0, startLeft + deltaX)
        );

        thumb.style.left = `${newLeft}px`;
        content.scrollLeft =
          (newLeft / container.clientWidth) * content.scrollWidth;
      };

      const onEnd = () => {
        enableTextSelection();
        document.removeEventListener(
          isTouch ? "touchmove" : "mousemove",
          onMove
        );
        document.removeEventListener(isTouch ? "touchend" : "mouseup", onEnd);
      };

      document.addEventListener(isTouch ? "touchmove" : "mousemove", onMove, {
        passive: false,
      });
      document.addEventListener(isTouch ? "touchend" : "mouseup", onEnd);
    };

    // Create bound event handlers
    const handleMouseDown = (e) => startDrag(e, false);
    const handleTouchStart = (e) => startDrag(e, true);

    thumb.addEventListener("mousedown", handleMouseDown);
    thumb.addEventListener("touchstart", handleTouchStart);

    return () => {
      content.removeEventListener("scroll", updateThumbPosition);
      thumb.removeEventListener("mousedown", handleMouseDown);
      thumb.removeEventListener("touchstart", handleTouchStart);
    };
  }, []);

  return (
    <div className="container">
      <div className="scroll-content">
        <div className="image-container-futuresComp3 times-new-roman">
          <div className="image-futuresComp4">
            <img
              src={ShapesFutures1}
              alt="Futures series - Watercolour, oil pastel and pencil on paper"
            />
            <p className="image-description">
              Watercolour, oil pastel and pencil on paper 148 x 210
            </p>
          </div>
          <div className="image-futuresComp4 smaller-f4">
            <img
              src={ShapesFutures2}
              alt="Futures series - Watercolour, oil pastel, pencil and thread on paper"
            />
            <p className="image-description">
              Watercolour, oil pastel, pencil and thread on paper <br /> 148 x
              210{" "}
            </p>
          </div>
          <div className="image-futuresComp4">
            <img
              src={ShapesFutures3}
              alt="Futures series - Oil pastel on paper"
            />
            <p className="image-description">Oil pastel on paper 148 x 210</p>
          </div>
        </div>
      </div>
      <div className="custom-scrollbar f4">
        <div className="scrollbar-thumb f4">
          <span className="scrollbar-text">scroll me</span>
        </div>
      </div>
    </div>
  );
};

export default FuturesComp4;
